import {ApiItem} from "./models/reportAssignment";

export const groupByDepartment = (data: any[]): ApiItem[] =>
  Object.values(
    data.reduce((acc, { id, assign }) => {
      if (!assign) return acc;

      acc[assign] ??= { assign, ids: [] };
      acc[assign].ids.push(id);

      return acc;
    }, {} as ApiItem)
  );